import { render, staticRenderFns } from "./maintenanceAffiliation.vue?vue&type=template&id=5b41fa40&scoped=true"
import script from "./maintenanceAffiliation.vue?vue&type=script&lang=js"
export * from "./maintenanceAffiliation.vue?vue&type=script&lang=js"
import style0 from "./maintenanceAffiliation.vue?vue&type=style&index=0&id=5b41fa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b41fa40",
  null
  
)

export default component.exports